import { Router } from "@angular/router";

export function getGeneralRoutePath(router: Router): string {
  const urlSegments = router.url.split('/').filter(s => s);
  return  urlSegments.slice(1).join('/');
}

export function getOrganizationFromPath(router: Router): string {
    // Parse instead of splitting the raw URL: a query string or fragment on the
    // first segment (e.g. /not-found?resource=organization) must not leak into
    // the returned segment name.
    const segments = router.parseUrl(router.url).root.children['primary']?.segments ?? [];
    return segments[0]?.path ?? '';
}
